import { RouteIcon, ShieldCheckIcon, PrinterIcon, InfinityIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface TrustPoint {
  icon: LucideIcon
  title: string
  description: string
}

export const trustPoints: TrustPoint[] = [
  {
    icon: RouteIcon,
    title: "Une progression pensée pour l'enseignement réel",
    description: '6 niveaux construits bloc par bloc, pas une liste d’exercices sans ordre.',
  },
  {
    icon: ShieldCheckIcon,
    title: 'La sécurité intégrée, pas ajoutée après coup',
    description:
      'Fiches d’anatomie, contre-indications et adaptations spécifiques incluses dans le pack.',
  },
  {
    icon: PrinterIcon,
    title: 'Prêt à imprimer dès le premier jour',
    description: 'Aucune mise en page à refaire, aucun format à adapter.',
  },
  {
    icon: InfinityIcon,
    title: 'Un accès à vie, pas un abonnement',
    description: 'Vous payez une fois, le contenu et ses mises à jour restent à vous.',
  },
]
